import { Box, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import styles from "./ToolTabs.module.css";

type TabType = {
	key: string;
	label: string;
	color: {
		backgroundColor: string;
		borderColor: string;
	};
	icon: React.ReactNode;
};

type ToolTabsProps = {
	tabs: TabType[];
	onChange: Dispatch<SetStateAction<string>>;
};

export default function ToolTabs({ tabs, onChange }: ToolTabsProps) {
	return (
		<div className={styles.tabWrapper}>
			{tabs.map((tab) => (
				<div key={tab.key} className={styles.tab} onClick={() => onChange(tab.key)}>
					<Box className={styles.iconWrapper} bgcolor={tab.color.backgroundColor} borderColor={tab.color.borderColor}>
						{tab.icon}
					</Box>
					<Typography className={styles.tabName}>{tab.label}</Typography>
				</div>
			))}
		</div>
	);
}
